import React from 'react';


function Footer(){
  return (
    <footer>
      <div className="footer-container">
        <p>Projet réalisé par Sébastien Ternest</p>
        <p>Les icônes Wolverine, Iron-man, Spider-man, batman sont prises sur le site iconFinder</p>
      </div>
    </footer>
  );
}

export default Footer;
